// Pricing display helpers — keep the UI consistent across components.
export const formatPrice = (amount, currency = "INR") => {
  const symbol = currency === "USD" ? "$" : "₹";
  // INR: no decimals. USD: 2 decimals (the standard for our tiers).
  if (currency === "USD") {
    return `${symbol}${Number(amount).toFixed(2)}`;
  }
  return `${symbol}${Math.round(Number(amount))}`;
};

export const pricingLabel = (pricing) => {
  if (!pricing) return "";
  return `${formatPrice(pricing.price, pricing.currency)} · ${pricing.access_days} days`;
};
